import { render } from "./RestyleTextarea.vue?vue&type=template&id=7572bcc4&scoped=true"
import script from "./RestyleTextarea.vue?vue&type=script&lang=js"
export * from "./RestyleTextarea.vue?vue&type=script&lang=js"

import "./RestyleTextarea.vue?vue&type=style&index=0&id=7572bcc4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7572bcc4"]])

export default __exports__